/* eslint-disable no-unused-vars */
/**
 * Shared enums used across Value Matching APIs.
 * These are referenced by multiple API operations (list, create, modify, view, cancel).
 */

/** Campaign type — determines the campaign category and applicable UI/business rules */
export enum CampaignType {
  CASHBACK = 'CASHBACK',
  BUYBACK = 'BUYBACK',
  DEAL = 'DEAL',
  NO_COST_EMI = 'NO_COST_EMI',
  INSTANT_BANK_DISCOUNT = 'INSTANT_BANK_DISCOUNT',
}

/** IBD instrument / card type */
export enum InstrumentType {
  CC = 'CC',
  DC = 'DC',
  CCEMI = 'CCEMI',
  DCEMI = 'DCEMI',
}

/** IBD event type */
export enum EventType {
  BAU = 'BAU',
  HVE = 'HVE',
}

/** Campaign lifecycle status */
export enum CampaignStatus {
  ACTIVE = 'ACTIVE',
  PAUSED_FUNDS_DEPLETED = 'PAUSED_FUNDS_DEPLETED',
  SCHEDULED = 'SCHEDULED',
  PROPAGATING = 'PROPAGATING',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED',
  OVERRIDDEN = 'OVERRIDDEN',
}

/** Payment instrument type — used in No Cost EMI guardrails and campaign configurations */
export enum PaymentInstrumentType {
  CREDIT_CARD = 'CREDIT_CARD',
  DEBIT_CARD = 'DEBIT_CARD',
  BFL_CARD = 'BFL_CARD',
  FLIPKART_CARD = 'FLIPKART_CARD',
}

/** Currency code — used in Currency and PositiveValueCurrency */
export enum CurrencyCode {
  INR = 'INR',
  USD = 'USD',
}

/** Rounding option for cashback values */
export enum RoundingOption {
  FIVE = 'FIVE',
  TEN = 'TEN',
  FIFTY = 'FIFTY',
  HUNDRED = 'HUNDRED',
}

/** Funding share type for NCEMI campaigns */
export enum FundingShareType {
  AMAZON = 'AMAZON',
  BANK = 'BANK',
  BRAND = 'BRAND',
  SELLER = 'SELLER',
}

/** Merchant group behaviour for default UI rendering */
export enum MerchantGroupBehaviour {
  DEFAULT = 'DEFAULT',
  REGULAR = 'REGULAR',
}

/** Operation status for API responses */
export enum OperationStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

/** User role derived from PAAM scope */
export enum UserRole {
  SELLER = 'SELLER',
  BRAND = 'BRAND',
  AMAZON = 'AMAZON',
}

/** The type of operation for which request is coming — e.g., creating or modifying a campaign */
export enum OperationType {
  CREATE_CAMPAIGN = 'CREATE_CAMPAIGN',
  MODIFY_CAMPAIGN = 'MODIFY_CAMPAIGN',
}

/** Brand sweetener toggle option — used in Buyback campaign forms */
export enum BrandSweetenerOption {
  YES = 'yes',
  NO = 'no',
}
